import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import limparUltimosHistoricosItinerario from '../../actions/itinerario/limparUltimosHistoricosItinerario';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = ({habilitadoSite}) => (
    <div className="lista-eventos titulo">
      <div className="row cabecalho-desktop" style={{ fontWeight: 'bold'}}>
        <div className="col-12 col-sm-12 col-md">Data e Hora</div>
        <div className="col-12 col-sm-12 col-md">Situação</div>
        <div className="col-12 col-sm-12 col-md">Usuário</div>        
        <div className="col-12 col-sm-12 col-md">Data/Hora saída</div>        
        <div className="col-12 col-sm-12 col-md">Veículo</div>
        <div className="col-12 col-sm-12 col-md">Rota</div>
        <div className="col-12 col-sm-12 col-md">Prestador</div>
        <div className="col-12 col-sm-12 col-md">Categoria</div>
        <div className="col-12 col-sm-12 col-md">Itinerário ativo/inativo</div>
        {habilitadoSite 
            && <div className="col-12 col-sm-12 col-md">Venda Site<br/>Ativo/Inativo</div>}
      </div>
    </div>
  );

export class ModalHistoricoItinerario extends Component {

    fecharModal () {
        $('#modalHistoricoItinerario')
            .modal('hide');
        $('#modalHistoricoItinerario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHistoricosItinerario();
        this.props.selecionarItinerario(null);
    }

    exibirItinerarioAtivo(historico) {
        // eslint-disable-next-line no-undef
        if (!_.isNil(historico.itinerario.ativo)) {
            if (historico.itinerario.ativo) {
                return <p>Sim</p>
            } else {
                return <p>Não</p>
            }
        }

        return '';
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.dataEvento}`}>
                <div className="row conteudo-desktop">
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">                            
                            <Moment
                                format="DD/MM/YYYY">{historico.itinerario.dataPartida}</Moment> {historico.itinerario.horaSaida}
                        </div>
                    </div>                    
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.itinerario.veiculoDto ? historico.itinerario.veiculoDto.descricao : ''}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            {historico.itinerario.rotaDto.cidadeOrigem.nome}-
                            {historico.itinerario.rotaDto.cidadeOrigem.uf} à {historico.itinerario.rotaDto.cidadeDestino.nome}-
                            {historico.itinerario.rotaDto.cidadeDestino.uf}
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.itinerario.prestador ? historico.itinerario.prestador.valor : 'Frota própria'}</p>
                        </div>
                    </div> 
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.itinerario.descricaoTipoVeiculo ? historico.itinerario.descricaoTipoVeiculo : historico.itinerario.tipoPreco.tipoPreco}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            {this.exibirItinerarioAtivo(historico)}
                        </div>
                    </div>
                    {this.props.empresaSelecionada.habilitadoSite ? <div className="col-12 col-sm-12 col-md">
                        <div id="evento" className="texto">
                            <p>{historico.itinerario.habilitadoSite ? 'Sim' : 'Não'}</p>
                        </div>
                    </div>:''}
                </div>
                <div className="row conteudo-desktop mb-2">
                    <div className="col-12 col-sm-4 col-md">
                        {historico.itinerario.trechosBloqueados && historico.itinerario.trechosBloqueados.length 
                            ? <ul><li style={{listStyleType: 'none'}}><strong>Bloqueio de venda em trechos:</strong><ul>
                                {historico.itinerario.trechosBloqueados.map((it, indice) => {
                                    return <li key={`trecho-bloqueado-${indice}`}>
                                        {it.trechoOrigem.valor} - {it.trechoDestino.valor}
                                    </li>
                                })}
                            </ul></li>
                        </ul>: ''}
                    </div>
                    <div className="col-12 col-sm-4 col-md">
                        {historico.itinerario.cidadesBloqueados && historico.itinerario.cidadesBloqueados.length
                            ? <ul><li style={{listStyleType: 'none'}}><strong>Bloqueio de venda por cidades</strong><ul>
                                {historico.itinerario.cidadesBloqueados.map((it, indice) =>{
                                    return <li key={`cidade-bloqueado-${indice}`}>
                                        {it.cidade.valor}
                                    </li>
                                })}
                            </ul></li>
                            </ul>: ''}
                    </div>
                    <div className="col-12 col-sm-4 col-md">
                        {historico.itinerario.motoristas && historico.itinerario.motoristas.length
                            ? <ul><li style={{listStyleType: 'none'}}><strong>Vinculo de motoristas</strong><ul>
                                {historico.itinerario.motoristas.map((it, indice) =>{
                                    return <li key={`motorista-${indice}`}>
                                        {it.nome}
                                    </li>
                                })}
                            </ul></li>
                            </ul>: ''}
                    </div>
                </div>
            </div>)
        }
        return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoItinerario' role='dialog'
            aria-labelledby='modalHistoricoItinerario' aria-hidden='true' data-backdrop='static'>
            <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Históricos Itinerário {this.props.itinerarioSelecionado.id}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <i className="material-icons" onClick={() => this.fecharModal()}>
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Cabecalho habilitadoSite={this.props.empresaSelecionada.habilitadoSite} />
                        {this.exibirHistoricos()}
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {        
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
        historicos: state.ultimosHistoricosItinerario
    }
};

export default connect(mapStateToProps, {
    limparUltimosHistoricosItinerario,
    selecionarItinerario
})(ModalHistoricoItinerario)